import { createFileRoute } from '@tanstack/react-router'
import { SupplierPaymentPrintPage } from '../../../../features/purchasing/voucher-print-pages'
import { voucherPrintSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/supplier-payments/$paymentId/print')({
  // The print pages share one crumb label ("Print").
  staticData: { crumb: 'purchasePrint' },
  validateSearch: voucherPrintSearchSchema,
  component: SupplierPaymentPrintPage,
})
